module.exports = __webpack_public_path__ + "static/img/MQ_MAS_HOR_RGB_POS.f035e71.png";


//////////////////
// WEBPACK FOOTER
// ./static/MQ_MAS_HOR_RGB_POS.png
// module id = MxZE
// module chunks = 0 1